module.exports = __webpack_public_path__ + "img/logo.5b56c06b.png";